import { Link, usePage } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import Heading from "@/components/heading"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { backofficeUsersPath } from "@/routes"

const tabs = [{ title: "Users", href: backofficeUsersPath() }]

export default function BackofficeLayout({ children }: PropsWithChildren) {
  const { url } = usePage()

  return (
    <div className="bg-background min-h-screen">
      <div className="border-b">
        <div className="container mx-auto px-4 py-4">
          <Heading title="Backoffice" description="Admin panel" />
        </div>
      </div>

      <div className="container mx-auto px-4 py-6">
        <nav className="mb-6 flex space-x-1 border-b">
          {tabs.map((tab) => (
            <Button
              key={tab.href}
              variant="ghost"
              size="sm"
              asChild
              className={cn(
                "rounded-b-none border-b-2 border-transparent",
                url.startsWith(tab.href) && "border-primary",
              )}
            >
              <Link href={tab.href}>{tab.title}</Link>
            </Button>
          ))}
        </nav>

        <main>{children}</main>
      </div>
    </div>
  )
}
